import { init as initApm } from '@elastic/apm-rum'
import { apm } from '@elastic/apm-rum'
import { History } from 'history'

import { version } from '../../../../../../package.json'
import { IErrorLogger, HTTPException, severityLevel } from '../../types'

export class ElasticAdapter implements IErrorLogger {
  history?: History

  getNavigationHistory(history: History): void {
    this.history = history
  }

  init(): void {
    initApm({
      serviceName: process.env.REACT_APP_ELASTIC_APM_SERVICE_NAME,
      serverUrl: process.env.REACT_APP_ELASTIC_APM_SERVER_URL,
      environment: process.env.REACT_APP_ELASTIC_APM_ENVIRONMENT,
      serviceVersion: version,
    })
  }

  captureException(
    transactionName: string,
    severityLevel: severityLevel,
    error: Error,
    details: Record<string, any>,
  ): void {
    if (details) {
      apm.addLabels({ errorDetails: JSON.stringify(details) })
    }
    // apm.setTransactionName(transactionName);
    apm.captureError(error)
  }

  captureLog(
    message: string,
    severityLevel: severityLevel,
    details: Record<string, any>,
  ): void {
    if (details) {
      apm.addLabels({ errorDetails: JSON.stringify(details) })
    }
    apm.captureError(message)
  }

  captureUIException(error: Error, { componentStack }: React.ErrorInfo): void {
    apm.addLabels({ componentStack: JSON.stringify(componentStack) })
    apm.captureError(error)
  }

  captureHTTPException(error: HTTPException): void {
    apm.addLabels({
      ...(error?.config?.url && {
        requestUrl: error.config.url,
      }),
      ...(error?.response?.status && {
        statusCode: error.response.status,
      }),
      ...(error?.config?.method && {
        requestMethod: error.config.method,
      }),
      ...(error?.response?.data?.error && {
        errorMessage: error.response.data.error,
      }),
      genericErrorMessage: error?.message,
    })

    apm.captureError(error)
  }
}
